
import { Outlet, Link } from 'react-router-dom';
import { apiService } from '../../../services';
import { Footer } from '../../';
import { Helmet } from 'react-helmet';
import { Header, Notifications } from '../../';
import { ToastContainer } from 'react-toastify';
import i18n from "../../../i18n";
import { useHeroItems } from '../../../modules';
import { configService } from '../../../services';

import { doLogin, LoginWith } from '../../../hooks'
import { useEffect } from 'react';

// import SocialIntentsChat from '../../Chat/SocialIntentsChat.component';

const isLoggedIn = apiService.instance.isLoggedIn();
console.log('isLoggedIn', isLoggedIn);

export default function RicohLayout() {
    const {
        HeroFeed
    } = useHeroItems();

    const t = i18n.t;
    console.log('isLoggedIn', isLoggedIn);

    useEffect(() => {
        if (isLoggedIn) return;
        const timeout = setTimeout(() => doLogin(undefined, LoginWith.Unifyr), 500);
        return () => clearTimeout(timeout);
    }, []);


    return (<>
        {isLoggedIn ? (
            <>
                <Notifications />
                <ToastContainer autoClose={false} closeOnClick />
                <Header />
                <Outlet />
                <Footer />
                {/* <SocialIntentsChat /> */}
            </>
        ) : (
            <>
                {/* <LoginTile /> */}
                {/* {doLogin(undefined, LoginWith.Unifyr)} */}
                {/* <Helmet>
                    <title>{configService.current().applicationTitle} - Welcome to {i18n.t("app_name")}</title>
                </Helmet>
                <div className='d-flex flex-column align-items-center justify-content-center gap-3 text-center p-3' style={{ height: '100vh' }}>
                    {t("page_welcome_heading")}
                    <div className='d-flex flex-column flex-sm-row align-items-center justify-content-center gap-3'>
                        <button className='btn btn-primary m-x-05 text-decoration-none' onClick={() => doLogin()}>Login with Channel 360</button>
                        <button className='btn btn-primary m-x-05 text-decoration-none' onClick={() => doLogin(undefined, LoginWith.Azure)}>Login with Azure</button>
                        <button className='btn btn-primary m-x-05 text-decoration-none' onClick={() => doLogin(undefined, LoginWith.Unifyr)}>
                            {t("page_welcome_button_unifyr_text")}
                        </button>
                    </div>
                </div> */}
            </>
        )}
    </>
    );

}